import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import 'rxjs/add/operator/filter';
import { Helpers } from '../../helpers';

@Component({
    selector: 'breadcrumb',
    templateUrl: './breadcrumb.component.html'
})
export class BreadcrumbComponent implements OnInit {
    breadcrumbs: Array<Object> = [];
    homepage: string;
    title: string;
    constructor(private router: Router, private route: ActivatedRoute) {
        var self = this;
        this.homepage = '/' + Helpers.getPath();
        this.router.events
            .filter(event => event instanceof NavigationEnd)
            .subscribe(event => {
                self.breadcrumbs = [];
                let currentRoute = this.route.root,
                    url = '';
                do {
                    let childrenRoutes = currentRoute.children;
                    currentRoute = null;
                    childrenRoutes.forEach(route => {
                        if (route.outlet === 'primary') {
                            let routeSnapshot = route.snapshot;

                            url +=
                                '/' + routeSnapshot.url.map(segment => segment.path).join('/');
                            self.breadcrumbs.push({
                                label: route.snapshot.data.breadcrumb,
                                url: route.snapshot.data.url,
                                queryParams: route.snapshot.data.queryParams
                            });
                            currentRoute = route;
                            self.title = route.snapshot.data.title;
                        }
                    });
                } while (currentRoute);
            });
    }
    ngOnInit() { }
}



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/theme/breadcrumb/breadcrumb.component.ts